<div class="modal-header">
	<h4 class="modal-title">
		<span jhiTranslate="cop.matrix.header"></span>
        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
</div>
<div class="modal-body">
	<div>
		<i class="throbber" *ngIf="isLoading"></i>
	</div>
	<div class="row" *ngIf="hasResponseOnlyMatrix() else asyncInProgress">
		<div class="col">
			<div class="row mb-3">
				<div class="col">
					<form>
						<div class="mb-3 row">
							<label class="col-auto col-form-label" for="nameCode" jhiTranslate="cop.matrix.name.dropdown"></label>
							<div class="col-auto">
								<select class="form-select" id="nameCode" name="nameCode" [(ngModel)]="nameKeySelected">
									<option [value]="GID">{{GID}}</option>
									<ng-container *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">
										<option *ngFor="let nameCode of keys(response.germplasmCommonNamesMap)" [value]="nameCode">{{nameCode}}</option>
									</ng-container>
								</select>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr>
						<th *ngFor="let gid of response?.upperTriangularMatrix[0]">{{getName(gid)}}</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let row of response?.upperTriangularMatrix.slice(1); index as i">
						<td *ngFor="let col of row; index as j" [class.font-weight-bold]="j === 0" [style.backgroundColor]="j > 0 && (col || col === '0') ? getColor(col) : ''">
							{{j === 0 ? getName(col) : col | number: '1.0-4'}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="row mb-3">
				<div class="col">
				</div>
			</div>
		</div>
	</div>
	<ng-template #asyncInProgress>
		<div *ngIf="!isLoading && response">
			<div class="mb-3">
				<span jhiTranslate="cop.async.in.progress"></span>
				<button type="button" class="btn btn-secondary ms-3" (click)="cancelJobs()">
					<span class="fa fa-ban"></span>&nbsp;<span [title]="cancelTooltip" jhiTranslate="entity.action.cancel"></span>
				</button>
			</div>
			<div class="progress">
				<div class="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar"
					 [attr.aria-valuenow]="progressValue()" aria-valuemin="0" aria-valuemax="100"
					 [style.width.%]="progressValue()">{{progressValue() | number}} % {{progressLabel()}}
				</div>
			</div>
		</div>
	</ng-template>
</div>
<div class="modal-footer" *ngIf="hasResponseOnlyMatrix()">
	<div class="d-flex align-items-center">
		<div class="mb-3">
			<input type="radio" id="exportInXLS" name="exportInXLS" [(ngModel)]="isExportInXLSX" [value]="true" checked>
			<label class="ms-1" for="exportInXLS" jhiTranslate="cop.matrix.xlsx">xlsx</label>
		</div>
		<div class="mb-3">
			<input class="ms-3" type="radio" id="exportInCSV" name="exportInCSV" [(ngModel)]="isExportInXLSX" [value]="false" checked>
			<label class="ms-1" for="exportInCSV" jhiTranslate="cop.matrix.csv">csv</label>
		</div>
		<div class="mb-3">
			<button (click)="downloadMatrix()" class="btn btn-info ms-3"><span jhiTranslate="cop.matrix.download"></span></button>
		</div>
	</div>
</div>
